import React, { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');
    try {
      const response = await fetch('https://python.rock-safaris.com/contact/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      if (response.ok) {
        setStatus(result.message);
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setStatus('Error: ' + result.message);
      }
    } catch (error) {
      setStatus('An error occurred while sending your message');
    }
  };

  return (
    <div>
      <section className="bg-kenya-yellow py-5">
        <div className="container text-center py-4">
          <h1 className="display-5 fw-bold text-kenya-brown mb-3">Contact Us</h1>
          <p className="lead text-kenya-brown mx-auto" style={{ maxWidth: 700 }}>
            Get in touch with us to start planning your dream safari adventure
          </p>
        </div>
      </section>

      <section className="py-5 bg-kenya-white">
        <div className="container">
          <div className="row g-5">

            <div className="col-md-5">
              <h2 className="fw-bold text-kenya-brown mb-4">Get in Touch</h2>
              <div className="mb-4 d-flex align-items-start">
                <span className="bg-kenya-yellow rounded-circle d-inline-flex align-items-center justify-content-center me-3" style={{ width: 48, height: 48 }}>
                  <Phone size={24} className="text-kenya-orange" />
                </span>
                <div>
                  <h6 className="fw-semibold mb-1">Phone Number</h6>
                  <div>+254792400119</div>
                  
                </div>
              </div>
              <div className="mb-4 d-flex align-items-start">
                <span className="bg-kenya-yellow rounded-circle d-inline-flex align-items-center justify-content-center me-3" style={{ width: 48, height: 48 }}>
                  <Mail size={24} className="text-kenya-orange" />
                </span>
                <div>
                  <h6 className="fw-semibold mb-1">Email</h6>
                  <div>info@rock-safaris.com</div>
                </div>
              </div>
              <div className="mb-4 d-flex align-items-start">
                <span className="bg-kenya-yellow rounded-circle d-inline-flex align-items-center justify-content-center me-3" style={{ width: 48, height: 48 }}>
                  <MapPin size={24} className="text-kenya-orange" />
                </span>
                <div>
                  <h6 className="fw-semibold mb-1">Location</h6>
                  <div>Nairobi, Kenya</div>
                </div>
              </div>
              <div className="bg-light rounded p-3">
                <h6 className="fw-semibold mb-2">Office Hours</h6>
                <div className="d-flex justify-content-between"><span>Monday - Friday:</span><span>8:00 AM - 6:00 PM</span></div>
                <div className="d-flex justify-content-between"><span>Saturday:</span><span>9:00 AM - 4:00 PM</span></div>
                <div className="d-flex justify-content-between"><span>Sunday:</span><span>Closed</span></div>
              </div>
            </div>

            <div className="col-md-7">
              <h2 className="fw-bold text-kenya-brown mb-4">Send us a Message</h2>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="phone" className="form-label">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="5"
                    required
                    className="form-control"
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-kenya-orange text-white fw-semibold px-4 py-2">
                  Send Message
                </button>
              </form>
              {status && <div className="alert alert-info mt-3">{status}</div>}
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;